import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconEvents = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M17.16 1.925c-.374.074-.864.398-1.133.75-.401.526-.411.615-.411 3.8v2.869h-4.025c-2.364 0-4.297.028-4.683.067-1.512.156-2.8.825-3.69 1.918-.449.553-.942 1.55-1.156 2.335l-.174.64v43.072l.17.613c.572 2.071 1.998 3.403 4.257 3.979l.565.144h50.496l.613-.17c2.071-.572 3.403-1.998 3.979-4.257l.144-.565V14.176l-.146-.576c-.592-2.336-2.478-3.895-5.07-4.193-.3-.034-2.337-.062-4.528-.062l-3.984-.001V6.476c0-3.186-.01-3.275-.411-3.8a2 2 0 0 0-1.984-.756c-.758.15-1.407.782-1.565 1.523-.047.222-.072 1.302-.072 3.12v2.781H19.655l-.02-2.96c-.017-2.685-.03-2.984-.134-3.216-.297-.661-.815-1.107-1.44-1.24-.382-.081-.502-.081-.9-.003M7.073 13.435c-.542.133-.866.468-1.062 1.097-.115.368-.122.64-.122 4.482v4.09h52.224V18.94c0-2.962-.022-4.249-.075-4.46-.094-.374-.476-.767-.918-.944-.306-.123-.492-.129-4.527-.146l-4.208-.018v1.286c0 1.668-.082 1.992-.647 2.548-.346.34-.67.476-1.217.508-.653.04-1.038-.09-1.488-.502-.586-.535-.64-.729-.668-2.412l-.024-1.424H19.66l-.022 1.424c-.022 1.41-.024 1.428-.201 1.789-.226.46-.709.902-1.143 1.046-.433.144-1.198.104-1.558-.082-.34-.175-.744-.592-.934-.963-.147-.289-.155-.366-.174-1.758l-.02-1.456-4.172.007c-2.295.003-4.258.027-4.364.053M5.888 41.94c0 12.999.012 14.844.096 15.13.13.438.468.737 1.027.91l.426.132h24.654c27.458 0 25.091.041 25.53-.444.145-.161.275-.406.36-.679.13-.425.131-.465.131-15.14V27.136H5.888zm37.449-10.379c-.118.035-.32.13-.448.213s-3.775 3.695-8.104 8.028l-7.871 7.877-2.817-2.812c-3.141-3.135-3.148-3.14-3.953-3.147-.539-.004-.878.093-1.211.348-.591.45-.842.957-.835 1.685.009.816-.088.699 3.88 4.682 1.975 1.981 3.72 3.685 3.878 3.787.56.358 1.443.376 2.006.04.33-.196 17.721-17.597 17.854-17.863.154-.31.23-.859.17-1.231-.19-1.175-1.399-1.938-2.55-1.607" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconEvents.displayName = 'IconEvents';